import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=23b12c81&"
import script from "./OptionCard.vue?vue&type=script&lang=js&"
export * from "./OptionCard.vue?vue&type=script&lang=js&"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=23b12c81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports